import styled from 'styled-components'
import { Editor } from '@tinymce/tinymce-react'
import React, { useRef } from 'react'
import { colors } from '../utils/config'

const StyledHTMLInput = styled.div`
  .tox-statusbar {
    display: none !important;
  }
  margin-bottom: 1rem;
  label,
  span {
    display: block;
  }
  label {
    font-family: 'Inter', sans-serif;
    font-size: 1rem;
    line-height: 1.5rem;
    color: ${colors.gray700};
    font-weight: 500;
  }
  span {
    font-family: 'Inter', sans-serif;
    font-size: 0.75rem;
    line-height: 1rem;
    color: ${colors.gray600};
    margin-bottom: 0.4rem;
  }
`

interface Props extends React.HTMLProps<HTMLInputElement> {
  desc?: string
  label?: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const HTMLInput = ({ onChange, value, id, name, desc, label }: Props) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const ref = useRef<any>(null)
  return (
    <StyledHTMLInput>
      {label && <label htmlFor={id}>{label}</label>}
      {desc && <span>{desc}</span>}
      {/* TODO: Externalize rich text editor to a single component */}
      <Editor
        onInit={(_evt, editor) => (ref.current = editor)}
        apiKey='8vx5y7rq8czx2uiyjxz384z1tgv52e698san9yj67z6h9z45'
        initialValue={value as string}
        id={id}
        onBlur={() => {
          const e = {
            target: {
              name,
              value: ref.current?.getContent(),
            },
          } as React.ChangeEvent<HTMLInputElement>
          onChange?.(e)
        }}
        init={{
          menubar: false,
          plugins: [
            'advlist',
            'autolink',
            'lists',
            'link',
            'image',
            'charmap',
            'preview',
            'anchor',
            'searchreplace',
            'visualblocks',
            'code',
            'fullscreen',
            'insertdatetime',
            'media',
            'table',
            'code',
            'help',
            'wordcount',
          ],

          toolbar: 'blocks | bold italic underline link  | bullist numlist |',
        }}
      />
    </StyledHTMLInput>
  )
}

export default HTMLInput
